import { useMemo } from 'react';

import { useConfig } from '../../defaultConfig';
import { useAvtaleGiroProposals } from '../../fetchHooks/useAvtalegiro';
import useQueryParam from '../../hooks/queryparams/useQueryParam';

const useAvtaleGiroKid = (): string | undefined => {
    const receiverAccountNumber = useQueryParam('receiverAccountNumber');
    const kid = useQueryParam('kid');
    const {
        featureToggles: { enableCheckAvtalegiroKid, enableAvtaleGiroProposals },
    } = useConfig();
    const proposalList = useAvtaleGiroProposals(enableAvtaleGiroProposals && enableCheckAvtalegiroKid);
    return useMemo(() => {
        if (!enableCheckAvtalegiroKid) {
            return kid;
        }
        const proposalsMatchingReceivers = (proposalList.data ?? []).filter(
            (avtaleGiroProposal) =>
                receiverAccountNumber && avtaleGiroProposal.proposal.toAccountNumber.value === receiverAccountNumber,
        );
        const kidMatch = proposalsMatchingReceivers.find(
            (avtaleGiroProposal) => avtaleGiroProposal.proposal.kid.value === kid,
        );

        if (kidMatch) {
            return kid;
        }
        if (proposalsMatchingReceivers && proposalsMatchingReceivers.length >= 1) {
            return proposalsMatchingReceivers[0].proposal.kid.value;
        }
        return kid;
    }, [enableCheckAvtalegiroKid, kid, proposalList.data, receiverAccountNumber]);
};

export default useAvtaleGiroKid;
